import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

/**
 * AppSurface — carte blanche claire (bordure fine, coins arrondis),
 * harmonisée avec les cartes de l'accueil. Remplace `GlassCard`/`PageHeader`
 * dans les écrans repris au nouveau style.
 */
const AppSurface: React.FC<{
  children: React.ReactNode;
  padding?: number | object;
  sx?: SxProps<Theme>;
}> = ({ children, padding, sx }) => (
  <Box
    sx={[
      {
        bgcolor: '#ffffff',
        border: '1px solid #e4e7ec',
        borderRadius: '16px',
        overflow: 'hidden',
        p: padding ?? { xs: 1.5, md: 2 },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Box>
);

export default AppSurface;
